
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/egypt/partners",
      function () {
        return require("private-next-pages/egypt/partners/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/egypt/partners"])
      });
    }
  